import {
  FETCH_PREFERENCES_REQUEST,
  FETCH_PREFERENCES_SUCCESS,
  FETCH_PREFERENCES_FAILURE,
  UPDATE_PREFERENCES_REQUEST,
  UPDATE_PREFERENCES_SUCCESS,
  UPDATE_PREFERENCES_FAILURE
} from './preferenceActionTypes'

const initialState = {
  loading: false,
  preferences: [],
  userPreferences: [],
  error: null
}

const preferenceReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PREFERENCES_REQUEST:
    case UPDATE_PREFERENCES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case FETCH_PREFERENCES_SUCCESS:
      return {
        ...state,
        loading: false,
        preferences: Array.isArray(action.payload.preferences) ? action.payload.preferences : [],
        userPreferences: Array.isArray(action.payload.userPreferences) ? action.payload.userPreferences : [],
        error: null
      }

    case UPDATE_PREFERENCES_SUCCESS:
      return {
        ...state,
        loading: false,
        userPreferences: action.payload,
        error: null
      }

    case FETCH_PREFERENCES_FAILURE:
    case UPDATE_PREFERENCES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default:
      return state
  }
}

export default preferenceReducer
